import urls from "global/constants/UrlConstants";
import { getCallParams, makeCall } from "utils/service";

export const fetchLastExecutedCampaign = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GET_LAST_EXECUTED_CAMPAIGN,
      callParams
    );

    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchCountsName = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GET_COUNTS_NAME, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchTotalActiveCount = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GET_TOTAL_ACTIVE_COUNT, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchDateWiseContactsCount = async (
  fromDate: Date | string | null,
  toDate: Date | string | null,
  searchText: string,
  status: number
) => {
  const body = {
    dateRange: {
      fromDate: fromDate,
      toDate: toDate,
    },
    entitySorters: [],
    searchText: searchText,
  };
  try {
    const url = `${urls.GET_DATE_WISE_CONTACTS_COUNT}/${status}/count/new`;
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchContactsGraph = async (
  fromDate: Date | string | null,
  toDate: Date | string | null,
  searchText: string,
  status: number
) => {
  const body = {
    dateRange: {
      fromDate: fromDate,
      toDate: toDate,
    },
    entitySorters: [],
    searchText: searchText,
  };
  try {
    const url = `${urls.GET_CONTACTS_GRAPH}/${status}/new`;
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchEmailSent = async (
  fromDate: Date | string | null,
  toDate: Date | string | null,
  searchText: string
) => {
  const body = {
    dateRange: {
      fromDate: fromDate,
      toDate: toDate,
    },
    entitySorters: [],
    searchText: searchText,
  };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GET_EMAIL_SEND, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchEmailSentGraph = async (
  fromDate: Date | string | null,
  toDate: Date | string | null,
  searchText: string
) => {
  const body = {
    dateRange: {
      fromDate: fromDate,
      toDate: toDate,
    },
    entitySorters: [],
    searchText: searchText,
  };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GET_EMAIL_SEND_GRAPH, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchEmailUsageLimit = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GET_EMAIL_USAGE_LIMIT, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
